import { useEffect, useState } from 'react';
import { deleteDataAPI, getDataAPI } from '../../Helpers/FetchAPI';
import { PreviousNoteCard } from '../⚛️atoms/PreviousNoteCard';
import { ChevronUpIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/16/solid';
import { Swipeable } from '../⚛️atoms/Swipeable';
import {useTranslation} from "react-i18next";

export const PreviousNoteGroup = ({ user, creditId, lastSubmit, newNoteClick, setSelectedEntry }) => {
  const [entries, setEntries] = useState([]);
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const updateEntries = () => {
    if (!user?.id) return;
    getDataAPI(`/api/user/notebooks/${user.id}`).then((res) => {
      const entryData = res.data.data
        .filter((note) => note.creditId === creditId)
        .flatMap((note) => note.entries)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setEntries(entryData);
    });
  };
  useEffect(() => {
    updateEntries();
  }, [user, lastSubmit]);

  const handleNoteEdit = (note) => {
    setSelectedEntry(note);
    setShow(false);
  };

  const handleNoteDelete = async (note) => {
    await deleteDataAPI(`/api/notebook/${note._id}/entry`);
    updateEntries();
  };

  return (
    <div
      className="absolute top-[98%] left-0 h-[93%] w-full -translate-y-10 transition-all duration-500 data-[show=true]:top-12 data-[show=true]:bg-white/80 data-[show=true]:px-3 data-[show=true]:backdrop-blur-xs"
      data-show={show}
    >
      <div
        className="flex w-full border-gray-200 pb-2 hover:cursor-pointer data-[show=false]:border-t-1"
        data-show={show}
        onClick={() => setShow(!show)}
      >
        <div className="grid w-full grid-cols-3 py-3">
          <div className="text-pddarkblue/80 flex items-center pl-3">
            <ChevronUpIcon className="size-10 transition-[rotate] data-[show=true]:rotate-180" data-show={show} />
            <span className="text-xl font-bold whitespace-nowrap">{show ? t('Hide') : t('Past Entries')}</span>
          </div>
          {show && (
            <div className="flex items-center gap-3 place-self-center" onClick={newNoteClick}>
              <div className="text-pddarkblue text-xl/7 font-bold whitespace-nowrap">{t("NEW NOTE")}</div>
              <PlusIcon className="size-6" />
            </div>
          )}
        </div>
      </div>
      <Swipeable className="h-full" onSwipeDown={() => setShow(false)}>
        <div
          className="no-scrollbar flex h-0 w-full flex-col gap-3 overflow-x-hidden overflow-y-scroll transition-[height] duration-500 data-[show=true]:h-full"
          data-show={show}
        >
          {entries.map((entry, index) => {
            return (
              <PreviousNoteCard
                note={entry}
                key={index}
                handleNoteEdit={(note) => handleNoteEdit(note)}
                handleNoteDelete={(note) => handleNoteDelete(note)}
              ></PreviousNoteCard>
            );
          })}
        </div>
      </Swipeable>
    </div>
  );
};